/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 *     // or ...
 *     if (any.isSameTypeAs(Foo.getDefaultInstance())) {
 *       foo = any.unpack(Foo.getDefaultInstance());
 *     }
 *
 *  Example 3: Pack and unpack a message in Python.
 *
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 *
 *  Example 4: Pack and unpack a message in Go
 *
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 *
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */
export interface Any {
  /**
   * A URL/resource name that uniquely identifies the type of the serialized
   * protocol buffer message. This string must contain at least
   * one "/" character. The last segment of the URL's path must represent
   * the fully qualified name of the type (as in
   * `path/google.protobuf.Duration`). The name should be in a canonical form
   * (e.g., leading "." is not accepted).
   *
   * In practice, teams usually precompile into the binary all types that they
   * expect it to use in the context of Any. However, for URLs which use the
   * scheme `http`, `https`, or no scheme, one can optionally set up a type
   * server that maps type URLs to message definitions as follows:
   *
   * * If no scheme is provided, `https` is assumed.
   * * An HTTP GET on the URL must yield a [google.protobuf.Type][]
   *   value in binary format, or produce an error.
   * * Applications are allowed to cache lookup results based on the
   *   URL, or have them precompiled into a binary to avoid any
   *   lookup. Therefore, binary compatibility needs to be preserved
   *   on changes to types. (Use versioned type names to manage
   *   breaking changes.)
   *
   * Note: this functionality is not currently available in the official
   * protobuf release, and it is not used for type URLs beginning with
   * type.googleapis.com. As of May 2023, there are no widely used type server
   * implementations and no plans to implement one.
   *
   * Schemes other than `http`, `https` (or the empty scheme) might be
   * used with implementation specific semantics.
   */
  "@type"?: string;
  [key: string]: any;
}

export interface AssignInstoreLocationRequest {
  email?: string;
  location_id?: string;
}

export interface AssignInstoreRoleRequest {
  email?: string;
  role?: string;
}

export interface AssignSigninSitesRequest {
  email?: string;
  /** NOTE signin_site_id is not named site_id as that conflicts with generic interceptor behaviour in svc-frontend, that is unrelated to this */
  signin_site_id?: string;
}

export interface AssignUserToGroupForMerchantRequest {
  group_id?: string;
  user_id?: string;
}

export type AssignUserToGroupForMerchantResponse = object;

export interface AssignUserToGroupRequest {
  group_id?: string;
  user_id?: string;
}

export interface AuthGroup {
  id?: string;
  name?: string;
  roles?: Role[];
  scope?: Scope;
}

/** @default "PASSWORD" */
export type AuthenticationType = "PASSWORD" | "OTHER";

export interface CreateGroupRequest {
  name?: string;
  role_ids?: string[];
  scope?: Scope;
}

export interface CreateGroupResponse {
  group_id?: string;
}

export interface CreateUserForMerchantRequest {
  authentication_type?: AuthenticationType;
  email?: string;
  external_id?: string;
  name?: string;
  nickname?: string;
  password?: string;
  picture?: string;
}

export interface CreateUserForMerchantResponse {
  user?: User;
}

export interface CreateUserRequest {
  authentication_type?: AuthenticationType;
  email?: string;
  external_id?: string;
  merchant_id?: string;
  name?: string;
  nickname?: string;
  password?: string;
  picture?: string;
}

export interface CreateUserResponse {
  user?: User;
}

export interface DeleteGroupRequest {
  id?: string;
}

export interface DeleteUserForMerchantRequest {
  id?: string;
}

export interface DeleteUserRequest {
  id?: string;
}

export interface GetGroupResponse {
  auth_group?: AuthGroup;
}

export interface GetUserForMerchantResponse {
  user?: MerchantUser;
}

export interface GetUserInfoResponse {
  user_info?: UserInfo;
}

export interface GetUserResponse {
  user?: User;
}

export interface GetUserWithTokenRequest {
  token?: string;
}

export interface GetUserWithTokenResponse {
  user?: User;
}

export interface ListGroupsResponse {
  auth_group?: AuthGroup[];
}

export interface ListMerchantUserSummariesResponse {
  summaries?: UserSummary[];
}

export interface ListRolesResponse {
  roles?: Role[];
}

export interface ListUserSummariesResponse {
  summaries?: UserSummary[];
}

export interface ListUsersForMerchantResponse {
  /** @format int64 */
  count?: string;
  users?: User[];
}

export interface ListUsersResponse {
  /** @format int64 */
  count?: string;
  users?: User[];
}

export interface MerchantUser {
  authentication_type?: AuthenticationType;
  email?: string;
  external_id?: string;
  groups?: AuthGroup[];
  id?: string;
  name?: string;
  roles?: UserRole[];
  super_user?: boolean;
}

export interface RemoveInstoreLocationRequest {
  email?: string;
  location_id?: string;
}

export interface RemoveInstoreRoleRequest {
  email?: string;
  role?: string;
}

export interface RemoveSigninSitesRequest {
  email?: string;
  /** NOTE signin_site_id is not named site_id as that conflicts with generic interceptor behaviour in svc-frontend, that is unrelated to this */
  signin_site_id?: string;
}

export interface RemoveUserFromGroupForMerchantRequest {
  group_id?: string;
  user_id?: string;
}

export type RemoveUserFromGroupForMerchantResponse = object;

export interface RemoveUserFromGroupRequest {
  group_id?: string;
  user_id?: string;
}

export interface Role {
  id?: string;
  name?: string;
}

export interface Scope {
  id?: string;
  type?: ScopeType;
}

/** @default "UNKNOWN" */
export type ScopeType = "UNKNOWN" | "SITE" | "MERCHANT";

export interface Status {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

export interface UpdateGroupRequest {
  id?: string;
  name?: string;
  role_ids?: string[];
}

export interface UpdateUserForMerchantRequest {
  authentication_type?: AuthenticationType;
  email?: string;
  external_id?: string;
  id?: string;
  name?: string;
  nickname?: string;
  password?: string;
  picture?: string;
}

export interface UpdateUserForMerchantResponse {
  user?: User;
}

export interface UpdateUserRequest {
  authentication_type?: AuthenticationType;
  email?: string;
  external_id?: string;
  id?: string;
  name?: string;
  nickname?: string;
  password?: string;
  picture?: string;
}

export interface UpdateUserResponse {
  user?: User;
}

export interface User {
  authentication_type?: AuthenticationType;
  email?: string;
  external_id?: string;
  groups?: AuthGroup[];
  id?: string;
  name?: string;
  /**
   * Deprecated: nickname was never actually used, will be removed at a later
   * time.
   */
  nickname?: string;
  /**
   * Deprecated: picture was never actually used, will be removed at a later
   * time.
   */
  picture?: string;
  roles?: UserRole[];
  super_user?: boolean;
}

export interface UserInfo {
  authentication_type?: AuthenticationType;
  email?: string;
  id?: string;
  instore_metadata?: UserInfoInstoreMetadata;
  name?: string;
  super_user?: boolean;
}

export interface UserInfoInstoreMetadata {
  location_ids?: string[];
  roles?: string[];
  site_id?: string;
}

export interface UserRole {
  id?: string;
  name?: string;
  scope?: Scope;
}

export interface UserSummary {
  email?: string;
  id?: string;
  is_superuser?: boolean;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/auth" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Auth API
 * @version 1.0
 * @baseUrl /v1/auth
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  admin = {
    /**
     * No description
     *
     * @name AuthorizationCreateGroup
     * @request POST:/admin/groups.create
     * @secure
     */
    authorizationCreateGroup: (body: CreateGroupRequest, params: RequestParams = {}) =>
      this.request<CreateGroupResponse, Status>({
        path: `/admin/groups.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationDeleteGroup
     * @request POST:/admin/groups.delete
     * @secure
     */
    authorizationDeleteGroup: (body: DeleteGroupRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/groups.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationGetGroup
     * @request GET:/admin/groups.get
     * @secure
     */
    authorizationGetGroup: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGroupResponse, Status>({
        path: `/admin/groups.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationListGroups
     * @request GET:/admin/groups.list
     * @secure
     */
    authorizationListGroups: (
      query?: {
        merchant_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListGroupsResponse, Status>({
        path: `/admin/groups.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationUpdateGroup
     * @request POST:/admin/groups.update
     * @secure
     */
    authorizationUpdateGroup: (body: UpdateGroupRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/groups.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationListRoles
     * @request GET:/admin/roles.list
     * @secure
     */
    authorizationListRoles: (params: RequestParams = {}) =>
      this.request<ListRolesResponse, Status>({
        path: `/admin/roles.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationListUserSummaries
     * @request GET:/admin/user_summaries.list
     * @secure
     */
    authorizationListUserSummaries: (
      query?: {
        ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ListUserSummariesResponse, Status>({
        path: `/admin/user_summaries.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationAssignUserToGroup
     * @request POST:/admin/users.assign_group
     * @secure
     */
    authorizationAssignUserToGroup: (body: AssignUserToGroupRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.assign_group`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationAssignInstoreLocation
     * @request POST:/admin/users.assign_instore_location
     * @secure
     */
    authorizationAssignInstoreLocation: (body: AssignInstoreLocationRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.assign_instore_location`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationAssignInstoreRole
     * @request POST:/admin/users.assign_instore_role
     * @secure
     */
    authorizationAssignInstoreRole: (body: AssignInstoreRoleRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.assign_instore_role`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationAssignSigninSites
     * @request POST:/admin/users.assign_signin_sites
     * @secure
     */
    authorizationAssignSigninSites: (body: AssignSigninSitesRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.assign_signin_sites`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationCreateUser
     * @request POST:/admin/users.create
     * @secure
     */
    authorizationCreateUser: (body: CreateUserRequest, params: RequestParams = {}) =>
      this.request<CreateUserResponse, Status>({
        path: `/admin/users.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationDeleteUser
     * @request POST:/admin/users.delete
     * @secure
     */
    authorizationDeleteUser: (body: DeleteUserRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationGetUser
     * @request GET:/admin/users.get
     * @secure
     */
    authorizationGetUser: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserResponse, Status>({
        path: `/admin/users.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationGetUserInfo
     * @summary GetUserInfo describes a User
     * @request GET:/admin/users.info
     * @secure
     */
    authorizationGetUserInfo: (
      query?: {
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserInfoResponse, Status>({
        path: `/admin/users.info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationListUsers
     * @request GET:/admin/users.list
     * @secure
     */
    authorizationListUsers: (params: RequestParams = {}) =>
      this.request<ListUsersResponse, Status>({
        path: `/admin/users.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationRemoveUserFromGroup
     * @request POST:/admin/users.remove_group
     * @secure
     */
    authorizationRemoveUserFromGroup: (body: RemoveUserFromGroupRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.remove_group`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationRemoveInstoreLocation
     * @request POST:/admin/users.remove_instore_location
     * @secure
     */
    authorizationRemoveInstoreLocation: (body: RemoveInstoreLocationRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.remove_instore_location`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationRemoveInstoreRole
     * @request POST:/admin/users.remove_instore_role
     * @secure
     */
    authorizationRemoveInstoreRole: (body: RemoveInstoreRoleRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.remove_instore_role`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationRemoveSigninSites
     * @request POST:/admin/users.remove_signin_sites
     * @secure
     */
    authorizationRemoveSigninSites: (body: RemoveSigninSitesRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/admin/users.remove_signin_sites`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationUpdateUser
     * @request POST:/admin/users.update
     * @secure
     */
    authorizationUpdateUser: (body: UpdateUserRequest, params: RequestParams = {}) =>
      this.request<UpdateUserResponse, Status>({
        path: `/admin/users.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  merchant = {
    /**
     * No description
     *
     * @name AuthorizationListMerchantUserSummaries
     * @request GET:/merchant/user_summaries.list
     * @secure
     */
    authorizationListMerchantUserSummaries: (
      query?: {
        ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ListMerchantUserSummariesResponse, Status>({
        path: `/merchant/user_summaries.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationAssignUserToGroupForMerchant
     * @request POST:/merchant/users.assign_group
     * @secure
     */
    authorizationAssignUserToGroupForMerchant: (
      body: AssignUserToGroupForMerchantRequest,
      params: RequestParams = {},
    ) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/merchant/users.assign_group`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationCreateUserForMerchant
     * @request POST:/merchant/users.create
     * @secure
     */
    authorizationCreateUserForMerchant: (body: CreateUserForMerchantRequest, params: RequestParams = {}) =>
      this.request<CreateUserForMerchantResponse, Status>({
        path: `/merchant/users.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationDeleteUserForMerchant
     * @request POST:/merchant/users.delete
     * @secure
     */
    authorizationDeleteUserForMerchant: (body: DeleteUserForMerchantRequest, params: RequestParams = {}) =>
      this.request<AssignUserToGroupForMerchantResponse, Status>({
        path: `/merchant/users.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationGetUserForMerchant
     * @request GET:/merchant/users.get
     * @secure
     */
    authorizationGetUserForMerchant: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserForMerchantResponse, Status>({
        path: `/merchant/users.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationListUsersForMerchant
     * @request GET:/merchant/users.list
     * @secure
     */
    authorizationListUsersForMerchant: (params: RequestParams = {}) =>
      this.request<ListUsersForMerchantResponse, Status>({
        path: `/merchant/users.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationRemoveUserFromGroupForMerchant
     * @request POST:/merchant/users.remove_group
     * @secure
     */
    authorizationRemoveUserFromGroupForMerchant: (
      body: RemoveUserFromGroupForMerchantRequest,
      params: RequestParams = {},
    ) =>
      this.request<RemoveUserFromGroupForMerchantResponse, Status>({
        path: `/merchant/users.remove_group`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorizationUpdateUserForMerchant
     * @request POST:/merchant/users.update
     * @secure
     */
    authorizationUpdateUserForMerchant: (body: UpdateUserForMerchantRequest, params: RequestParams = {}) =>
      this.request<UpdateUserForMerchantResponse, Status>({
        path: `/merchant/users.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  usersGetWithToken = {
    /**
     * No description
     *
     * @name AuthorizationGetUserWithToken
     * @request POST:/users.get_with_token
     * @secure
     */
    authorizationGetUserWithToken: (body: GetUserWithTokenRequest, params: RequestParams = {}) =>
      this.request<GetUserWithTokenResponse, Status>({
        path: `/users.get_with_token`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
